// test2178
(2178 && 0);
